import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getAgenzieRete } from "@/api/rete";
import type { AgenziaInCarico } from "@/types/rete";

/** Chiave URL condivisa da Pratiche e Clienti: `?agenzia=<account_id>`, assente = tutte. */
export const CHIAVE_AGENZIA = "agenzia";

/**
 * Tendina delle agenzie in carico. Il valore vive nell'URL, così il filtro
 * sopravvive al ricaricamento e si può passare come link (dal cruscotto).
 * Al cambio si azzera anche `pagina`: una lista filtrata riparte dalla prima.
 */
export function FiltroAgenzia() {
  const [sp, setSp] = useSearchParams();
  const [agenzie, setAgenzie] = useState<AgenziaInCarico[]>([]);

  useEffect(() => {
    let cancelled = false;
    getAgenzieRete()
      .then((a) => { if (!cancelled) setAgenzie(a); })
      .catch(() => { /* la tendina resta su «Tutte le agenzie»: il guasto lo dice già la lista sotto */ });
    return () => { cancelled = true; };
  }, []);

  const valore = sp.get(CHIAVE_AGENZIA) ?? "";

  function cambia(v: string) {
    setSp((prev) => {
      if (v) prev.set(CHIAVE_AGENZIA, v);
      else prev.delete(CHIAVE_AGENZIA);
      prev.delete("pagina");
      return prev;
    });
  }

  return (
    <select
      aria-label="Agenzia"
      value={valore}
      onChange={(e) => cambia(e.target.value)}
      className="min-h-[44px] px-3 py-2 border border-border rounded-lg text-sm bg-card"
    >
      <option value="">Tutte le agenzie</option>
      {agenzie.map((a) => (
        <option key={a.agenzia_id} value={a.agenzia_id}>{a.agenzia_nome}</option>
      ))}
    </select>
  );
}
